function initLPBenefitCards(sectionId = '') {
  const sectionElement = document.getElementById(sectionId);

  if (!sectionElement) {
    return;
  }

  const nextButton = sectionElement.querySelector('.lp-benefit-cards__next');
  const paginationElement = sectionElement.querySelector('.lp-benefit-cards__pagination');

  const desktopBreakpoint = {
    spaceBetween: 24,
  };

  new Swiper(sectionElement.querySelector('.swiper'), {
    slidesPerView: 'auto',
    spaceBetween: 12,
    speed: 600,
    navigation: { nextEl: nextButton },
    pagination: { el: paginationElement, clickable: true },
    breakpoints: { 750: desktopBreakpoint },
  });
}
